import { makeStyles } from "@material-ui/core";
import { Grid } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import CommonUtil from "../../components/Util/CommonUtils";
import { unblacklistVisitor } from "../../slices/BlacklistVisitor/BlacklistVisitorSlice";
import { ThemeContext } from "../../theme/ThemeContext";

const useStyles = makeStyles((theme) => ({
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
  dialogbox: {
    "& .MuiDialog-paper": {
      maxWidth: "600px",
      borderRadius: "20px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));


export default function UnblacklistVisitorForm(props) {
  const { open, handleClose } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles({ darkMode });
  const { darkMode } = useContext(ThemeContext);
  const [payload, setPayload] = React.useState({
    visitId: props.rowData.id,
    unrestrictedBy:
      props.rowData.visitor.lastName === null
        ? props.rowData.visitor.firstName
        : props.rowData.visitor.firstName +
        " " +
        props.rowData.visitor.lastName,
    unrestrictReason: "",
    name:
      props.rowData.visitor.lastName === null
        ? props.rowData.visitor.firstName
        : props.rowData.visitor.firstName +
        " " +
        props.rowData.visitor.lastName,
  });

  const [error, setError] = React.useState({
    unrestrictedBy: false,
    unrestrictReason: false,
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setError({
      [name]: false,
    });
  };

  const handleSubmit = () => {
    if (CommonUtil.isEmptyString(payload.unrestrictedBy)) {
      Toast(t("ENTER_VISITOR_NAME"), "error");
      setError({ unrestrictedBy: true });
      return false;
    }

    if (CommonUtil.isEmptyString(payload.unrestrictReason)) {
      Toast(t("ENTER_REASON"), "error");
      setError({ unrestrictReason: true });
      return false;
    }

    dispatch(unblacklistVisitor(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAE1047") {
          Toast(t("COMMON075"), "success");
          props.disable();
          handleClose();
        } else {
          Toast(data.message, "error");
        }
      });
  };

  return (
    <>
      <DialogBox
        Header={
          <span
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            {process.env.REACT_APP_ENVIRONMENT === "USA"
              ? t("UNBLOCKVIS002")
              : "Unblock Visitor"}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("COMMON035")}
        cancelText={t("dataTableCancel")}
        style={{ color: "#3D4977", opacity: 1, minHeight: "" }}
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          rowSpacing={2}
          style={{
            width: "100%",
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
          }}
        >
          <Grid item xs={12}>
            <CustomTextfield
              type={"text"}
              label={t("BLOCKVISITOR001")}
              error={error.unrestrictedBy}
              name="unrestrictedBy"
              value={payload.unrestrictedBy}
              handleChange={(e) => handleChange(e)}
              helperText={error.unrestrictedBy}
              required={true}
              inputProps={{ className: classes.input, maxLength: 120 }}
              disabled={true}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextfield
              type={"text"}
              label={t("BLOCKVISITOR002")}
              error={error.unrestrictReason}
              required={true}
              name="unrestrictReason"
              value={payload.unrestrictReason}
              handleChange={(e) => handleChange(e)}
              helperText={error.unrestrictReason}
              inputProps={{ className: classes.input, maxLength: 120 }}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
